import { useState } from "react";
import { downloadWordDocumentURL } from "../utils/ConstantsURL";
import { toastAlert } from "../utils/AlertContext";

export const useDownloadWordDocument = (token) => {
  const [loading, setLoading] = useState(false);

  const downloadWordDocument = async (documentData, signal) => {
    
    if (!documentData?.id_documento || !documentData?.fecha) {
      toastAlert("Error: Datos del documento incompletos", "error");
      return false;
    }

    setLoading(true);
    
    try {
      const response = await fetch(downloadWordDocumentURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id_documento: documentData.id_documento.toString(),
          fecha: documentData.fecha.toString(),
          config: {
            pageNumbering: {
              enabled: documentData.config?.pageNumbering?.enabled ?? true,
            },
            ...(documentData.config?.dateFormat
              ? { dateFormat: documentData.config.dateFormat }
              : {}),
            ...(documentData.config?.witnessConfig
              ? { witnessConfig: documentData.config.witnessConfig }
              : {}),
          },
          ...(documentData.templateType ? { templateType: documentData.templateType } : {}),
        }),
        signal: signal,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Error ${response.status}`);
      }

      const blob = await response.blob();
      
      let fileName;
      const contentDisposition = response.headers.get('content-disposition');
      
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename=["']?([^"';]+)["']?/i);
        if (filenameMatch && filenameMatch[1]) {
          fileName = decodeURIComponent(filenameMatch[1]);
        }
      }
      
      if (!fileName && documentData.nombreDocumento) {
        const safeName = documentData.nombreDocumento
          .replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s-]/g, '')
          .replace(/\s+/g, '_');
        fileName = `${safeName}_${documentData.fecha}.docx`;
      } else if (!fileName) {
        fileName = `documento-${documentData.fecha}.docx`;
      }
      
      if (!fileName.toLowerCase().endsWith('.docx')) {
        fileName += '.docx';
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toastAlert(`Documento "${fileName}" descargado correctamente`, "success");
      return true;
      
    } catch (error) {
      if (error.name === 'AbortError') {
        toastAlert("Descarga cancelada", "info");
        return false;
      }
      toastAlert("Error al descargar el documento: " + error.message, "error");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { downloadWordDocument, loading };
};